import { Array, Number, Record, Static, String } from "runtypes";

export const QuestionRequestRunType = Record({
  response: String,
  surveyQuestionId: Number,
  type: Number,
});

export interface IQuestionRequest
  extends Static<typeof QuestionRequestRunType> {}

export const SurveyRespondentRequestRuntype = Record({
  questionResponses: Array(QuestionRequestRunType),
  respondentName: String,
});

// all the questions
export interface ISurveyRespondentRequest
  extends Static<typeof SurveyRespondentRequestRuntype> {}

export interface IProperPostResponse {
  properAccessCode: boolean;
  properDataSent: boolean;
  finishedSurveySection: boolean;
  errorMessage: string;
}



// WEBPACK FOOTER //
// ./src/api/types/ISurveyRespondentRequest.ts